/******/ (() => { // webpackBootstrap
/*!*********************************!*\
  !*** ./src/js/pages/fanzone.js ***!
  \*********************************/
var _document$getElementB, _document$getElementB2;
document.addEventListener("DOMContentLoaded", function () {
  var owl = $('.fanzone-carousel');
  owl.owlCarousel({
    items: 1,
    loop: true,
    margin: 20,
    nav: false,
    dots: true,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 1
      },
      1024: {
        items: 1
      }
    }
  });

  // Custom navigation
  $('.next-btn').click(function () {
    owl.trigger('next.owl.carousel');
  });
  $('.prev-btn').click(function () {
    owl.trigger('prev.owl.carousel');
  });

  /* ================= EVENTS ================= */
  $(document).on('click', '.btn-forecast', function (e) {
    e.preventDefault();
    openModal();
  });
  $(document).on('click', '.btn-ratio', function (e) {
    e.preventDefault();
    openStatsModal();
  });
  $(document).on('click', '.btn-submit', function (e) {
    e.preventDefault();
    submitPrediction();
  });
  setupNumericInput('score1');
  setupNumericInput('score2');
  setupNumericInput('bonusAnswer');
});

// Input validation - only numbers
function setupNumericInput(inputId) {
  var input = document.getElementById(inputId);
  if (!input) return;
  input.addEventListener('input', function (e) {
    this.value = this.value.replace(/[^0-9]/g, '');
  });
  input.addEventListener('focus', function () {
    this.select();
  });
}

// Open modal with animation
window.openModal = function () {
  var modal = document.getElementById('predictionModal');
  if (!modal) {
    console.log("click");
    return;
  }
  ;
  modal.classList.remove('hidden');
  modal.classList.add('flex');
  document.body.style.overflow = 'hidden';

  // Clear inputs
  ['score1', 'score2', 'bonusAnswer'].forEach(function (id) {
    var input = document.getElementById(id);
    if (input) input.value = '';
  });
};

// Close modal
function closeModal() {
  var modal = document.getElementById('predictionModal');
  if (!modal) return;
  modal.classList.add('hidden');
  modal.classList.remove('flex');
  document.body.style.overflow = 'auto';
}

// Submit prediction
function submitPrediction() {
  var score1 = document.getElementById('score1').value.trim();
  var score2 = document.getElementById('score2').value.trim();
  var bonusAnswer = document.getElementById('bonusAnswer').value.trim();

  // Validate
  if (!score1 || !score2) {
    alert('Vui lòng nhập tỉ số dự đoán');
    return;
  }
  if (!bonusAnswer) {
    alert('Vui lòng trả lời câu hỏi phụ');
    return;
  }

  // Submit logic
  var prediction = {
    score: "".concat(score1, "-").concat(score2),
    bonusAnswer: parseInt(bonusAnswer)
  };
  console.log('Prediction submitted:', prediction);

  // Close modal
  closeModal();

  // Show success (you can replace with a nicer toast notification)
  setTimeout(function () {
    alert('Dự đoán của bạn đã được gửi thành công!');
  }, 300);
}

// Close on backdrop click
(_document$getElementB = document.getElementById('predictionModal')) === null || _document$getElementB === void 0 || _document$getElementB.addEventListener('click', function (e) {
  if (e.target === this) {
    closeModal();
  }
});

// Close on Escape key
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    var modal = document.getElementById('predictionModal');
    if (modal && !modal.classList.contains('hidden')) {
      closeModal();
    }
  }
});

// show popup xem so nguoi du doan
function openStatsModal() {
  var modal = document.getElementById('predictionStatsModal');
  if (!modal) return;
  modal.classList.remove('hidden');
  modal.classList.add('flex');
  document.body.style.overflow = 'hidden';
}
function closeStatsModal() {
  var modal = document.getElementById('predictionStatsModal');
  if (!modal) return;
  modal.classList.add('hidden');
  modal.classList.remove('flex');
  document.body.style.overflow = 'auto';
}
(_document$getElementB2 = document.getElementById('predictionStatsModal')) === null || _document$getElementB2 === void 0 || _document$getElementB2.addEventListener('click', function (e) {
  if (e.target === this) closeStatsModal();
});
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    var modal = document.getElementById('predictionStatsModal');
    if (modal && !modal.classList.contains('hidden')) closeStatsModal();
  }
});
/******/ })()
;
//# sourceMappingURL=fanzone.bundle.js.map